module.exports = __webpack_public_path__ + "img/no smile.3b5b14ea.png";